const  FilterSideBar=(props)=> {
    console.log(props)
    const storage = props.props
    return <div className="storage-details">
        {Object.entries(storage.categories).map(([category, info, icon]) => (
            // {{console.log(icon)}}
            <div key={category} className="storage-category">
               <div className="storage-filteritem"><i className={info.icon}></i>
                <span>{category}</span>
                </div>
                <span>{info.size}</span>
                {/* <span>{info.icon}</span> */}

            </div>
        ))}
    </div>;
}

export default FilterSideBar;